import Clipboard from "@react-native-clipboard/clipboard";
import { useCallback } from "react";

const useCopyToClipboard = (text?: Maybe<string>) => {
  const handleCopyToClipboard = useCallback(
    (passedText?: string) => {
      const copyString = passedText || text;

      if (copyString) {
        Clipboard.setString(copyString);
      }
    },
    [text],
  );

  return handleCopyToClipboard;
};

export default useCopyToClipboard;
